import { AssistantIf, ComposerPrimitive } from '@assistant-ui/react';
import { IconArrowUp, IconSquare } from '@tabler/icons-react';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';
import classes from './ComposerAction.module.css';

/** Renders the context-sensitive action button for the chat composer (send or cancel). */
export function ComposerAction() {
  return (
    <div className={classes.composerActions}>
      {/* asChild merges Send primitive behavior with TooltipIconButton without wrapper div */}
      <AssistantIf condition={({ thread }) => !thread.isRunning}>
        <ComposerPrimitive.Send asChild>
          <TooltipIconButton
            aria-label="Send message"
            color="white"
            position="left"
            size="sm"
            tooltip="Send message"
            type="submit"
            variant="transparent"
          >
            <IconArrowUp />
          </TooltipIconButton>
        </ComposerPrimitive.Send>
      </AssistantIf>

      {/* Allow users to interrupt streaming responses */}
      <AssistantIf condition={({ thread }) => thread.isRunning}>
        <ComposerPrimitive.Cancel asChild>
          <TooltipIconButton
            aria-label="Stop generating"
            color="white"
            position="left"
            size="sm"
            tooltip="Stop generating"
            type="submit"
            variant="transparent"
          >
            <IconSquare />
          </TooltipIconButton>
        </ComposerPrimitive.Cancel>
      </AssistantIf>
    </div>
  );
}
